export default __webpack_public_path__ + "static/3s-d8fbb6b95ccd1dcc20893fae8187e3d4.png";